type MainProps = {
  children: React.ReactNode;
};

export function Main({ children }: MainProps) {
  return (
    <main className='flex flex-col gap-10 items-center max-w-viewport w-full border-solid border-l-primary border-r-primary bg-primary flex-1'>
      {children}
    </main>
  );
}
